import React, { FunctionComponent, useEffect } from 'react';

import { useInitializeShoppingCart } from 'src/hooks/use-initialize-shopping-cart';
import { SummaryPageContent } from 'src/pages/summary/summary-page-content';
import { StyledContainer } from 'src/pages/summary/summary-page-content.styled';
import { selectIsCartPopulated, selectItemFromCart } from 'src/state/cart/selectors';
import { useAppDispatch, useAppSelector } from 'src/state/thunk-api';
import { withOrderStep } from 'src/hocs/with-order-step';
import { OrderStep } from 'src/state/order/types';
import { setReachedStep } from 'src/state/order/order-slice';
import { selectLastVisitedProductDetailsPage } from 'src/state/order/selectors';

import { SummaryPagePlaceholder } from './summary-page-placeholder';

const SummaryPageComponent: FunctionComponent = () => {
  const cart = useAppSelector(selectItemFromCart);
  const { initializeShoppingCart, isLoading, isUninitialized } = useInitializeShoppingCart();
  const lastVisitedPage = useAppSelector(selectLastVisitedProductDetailsPage);
  const isCartPopulated = useAppSelector(selectIsCartPopulated);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isCartPopulated) {
      initializeShoppingCart(cart);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart]);

  useEffect(() => {
    if (!isCartPopulated) {
      dispatch(setReachedStep(lastVisitedPage!));
    }
  }, [dispatch, isCartPopulated, lastVisitedPage]);

  return (
    <StyledContainer>
      {isLoading || isUninitialized ? <SummaryPagePlaceholder /> : <SummaryPageContent />}
    </StyledContainer>
  );
};

export const SummaryPage = withOrderStep(OrderStep.SUMMARY)(SummaryPageComponent);
